import TravelerPersonalDetailsContainer from './traveler-personal-details-container';

export default TravelerPersonalDetailsContainer;
